import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qctjfrupd6: FaireBrandEntity = {
  token: "b_qctjfrupd6",
  type: "brand",
  name: "Rustic Rays Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/c1f002cb6c424d13898d5ff22df66f6674a22ed76f17ee9329eee65e33300df5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a7c56a5116956d37cd693833bef00ef217c267d092b029d5bd1a79189ac9718.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c1f002cb6c424d13898d5ff22df66f6674a22ed76f17ee9329eee65e33300df5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a7c56a5116956d37cd693833bef00ef217c267d092b029d5bd1a79189ac9718.png",
  location: "Glen Carbon, IL, USA",
  minimumOrderDollars: 225,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "ORDERS SHIPPING WITHIN 4 BUSINESS DAYS! \n\nFALL COLLECTION AVAILABLE NOW! 🍂 Featuring Apple Cider, Butterscotch & Bourbon, Caramel Praline, Harvest Pear, and Pumpkin Sugar.\nㅤ\nRustic Rays Candle Co. is a woman-owned home fragrance brand proudly rooted in Illinois. We create elevated home fragrance with clean ingredients and timeless scents designed to become everyday favorites.\n\nEach collection is handcrafted in small batches using 100% soy wax, premium phthalate-free fragrance oils, and quality ingredients. Designed with intention, every scent is thoughtfully created to make homes feel inviting, comfortable, and beautifully lived in.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.018Z",
    importedBy: "entity-db-cli",
  },
};
